export default "__VITE_ASSET__D4t$gTFC__"